// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__z40T1","header":"PatientBlock_header__1HLkf","label":"PatientBlock_label__3n9ji","option":"PatientBlock_option__eptp4"};